export const ru = {
  globals: {},
  auth: {
    emailId: "Электронная почта",
    password: "Пароль",
    remember: "Запомнить меня",
    forgotPassword: "Забыли пароль",
    oldPass: "Старый пароль",
    confmPas: "Подтвердите пароль",
    otpVerification: "Проверка OTP",
    verify: "Проверить",
    resendOtp: "Отправить OTP повторно",
    login: "Войти",
    resendPass: "Сбросить пароль",
    editProfile: "Редактировать профиль",
    firstName: "Имя",
    lastName: "Фамилия",
    email: "Электронная почта",
    phone: "Номер телефона",
    loginToSura: "Войти в админку Sura Trade",
    emailAddress: "Адрес электронной почты",
    verifyOtp: "Подтвердить код",
    otpExpire: "Срок действия кода подтверждения истекает через",
    otpResent: "Код подтверждения успешно отправлен повторно",
  },
  main: {
    totalCustomers: "Всего клиентов",
    totalVendors: "Всего поставщиков",
    totalOrders: "Текущие заказы",
    completedOrders: "Завершённые заказы",
    cancelledOrders: "Отменённые заказы",
    totalCategories: "Всего категорий",
    totalSubCategories: "Всего подкатегорий",
    totalRevenue: "Общий доход",
    totalProductsListed: "Всего товаров",
    exportCsv: "Экспорт в CSV",
    sNo: "№",
    image: "Изображение",
    fullName: "Полное имя",
    phoneNumber: "Номер телефона",
    email: "Электронная почта",
    businessName: "Название компании",
    industryType: "Тип отрасли",
    address: "Адрес",
    manageAccount: "Управление аккаунтом",
    reject: "Отклонить",
    accept: "Принять",
    pending: "В ожидании",
    approved: "Одобрено",
    rejected: "Отклонено",
    deactivate: "Деактивировано",
    search: "Поиск",
    accountStatus: "Статус аккаунта",
    actions: "Действия",
    name: "Имя",
    subCategory: "Подкатегория",
    addCategory: "Добавить категорию",
    viewSubCategories: "Просмотреть подкатегории",
    selectCategory: "Выбрать категорию",
    selectSubCategory: "Выбрать подкатегорию",
    clearFilter: "Очистить фильтр",
    addProduct: "Добавить товар",
    productName: "Название товара",
    vendorName: "Имя поставщика",
    subCategoryName: "Название подкатегории",
    parentCategory: "Родительская категория",
    manageProduct: "Управление товарами",
    status: "Статус",
    todayDeals: "Сегодняшние предложения",
    bestDeals: "Лучшие предложения",
    customerName: "Имя клиента",
    inProgress: "В процессе",
    category: "Категория",
    productQuantity: "Количество товара",
    price: "Цена",
    specificReq: "Особые требования",
    chat: "Чат",
    quoteStatus: "Статус предложения",
    sendQuote: "Отправить предложение",
    deliveryConditions: "Условия доставки",
    shippingCharge: "Стоимость доставки",
    freeDelivery: "Бесплатная доставка",
    payment: "Оплата",
    refundable: "Возврат возможен",
    nonRefundable: "Без возврата",
    update: "Обновить",
    cancel: "Отменить",
    orderId: "ID заказа",
    date: "Дата",
    refundAmount: "Сумма возврата",
    amountSetByVendor: "Сумма, установленная поставщиком",
    refund: "Возврат",
    refundPayment: "Возврат платежа",
    addBanner: "Добавить баннер",
    banner: "Баннер",
    discountName: "Название скидки",
    discountPercentage: "Процент скидки",
    description: "Описание",
    type: "Тип",
    bannerType: "Тип баннера",
    startDate: "Дата начала",
    endDate: "Дата окончания",
    addDiscount: "Добавить скидку",
    onGoing: "В процессе",
    completed: "Завершено",
    orderTrackId: "Трек-номер заказа",
    userName: "Имя пользователя",
    subTotal: "Промежуточный итог",
    totalCost: "Общая стоимость",
    deliveryFees: "Плата за доставку",
    shippingAddress: "Адрес доставки",
    contact: "Контакт",
    orderStatus: "Статус заказа",
    paymentStatus: "Статус оплаты",
    orderPlaced: "Заказ размещён",
    shipping: "Доставка",
    delivered: "Доставлено",
    extraAmountPay: "Дополнительная сумма к оплате",
    totalCostPay: "Общая сумма к оплате",
    acceptReject: "Принять/Отклонить",
    inbox: "Входящие",
    totalPayments: "Общий объём платежей",
    pendingPayments: "Ожидающие платежи",
    amountPaidToVendor: "Сумма, выплаченная поставщику",
    makePayment: "Совершить платёж",
    pay: "Оплатить",
    addNotification: "Добавить уведомление",
    sentTo: "Отправлено",
    title: "Заголовок",
    messages: "Сообщения",
    delete: "Удалить",
    addSubAdmin: "Добавить суб-администратора",
    role: "Роль",
    add: "Добавить",
    platformCommission: "Комиссия платформы",
    tax: "Налог",
    responseTime: "Время ответа (в часах)",
    avgDeliveryTime: "Среднее время доставки (в днях)",
    save: "Сохранить",
    orderCancellationTime: "Время отмены заказа (в часах)",
    orderExchangeTime: "Время обмена заказа (в днях)",
    serviceFee: "Плата за обслуживание",
    general: "Общее",
    timing: "Время",
    contactSupport: "Связаться с поддержкой",
    privacyPolicy: "Политика конфиденциальности",
    agreement: "Соглашение",
    terms: "Условия и положения",
    cookiesPolicy: "Политика использования файлов cookie",
    about: "О нас",
    dataDeletion: "Политика удаления данных",
    conversionRate: "Курс обмена",
    conversionUsdToAed: "Курс обмена USD на AED",
    viewUserProfile: "Просмотр профиля клиента",
    back: "Назад",
    details: "Детали",
    documents: "Документы",
    city: "Город",
    pinCode: "Почтовый индекс",
    uploadedDocs: "Загруженные документы",
    clickToDownload: "Нажмите, чтобы скачать PDF",
    selectIndustry: "Выберите тип отрасли",
    categoryEn: "Название категории на английском",
    categoryAr: "Название категории на арабском",
    categoryRu: "Название категории на русском",
    addCat: "Добавить категорию",
    editCat: "Редактировать категорию",
    productNameEn: "Название продукта (на английском)",
    productNameAr: "Название продукта (на арабском)",
    productNameRu: "Название продукта (на русском)",
    gradeEn: "Качество (на английском)",
    gradeAr: "Качество (на арабском)",
    gradeRu: "Качество (на русском)",
    modelEn: "Модель № (на английском)",
    modelAr: "Модель № (на арабском)",
    modelRu: "Модель № (на русском)",
    images: "Изображения",
    editProduct: "Редактировать продукт",
    shelfEn: "Срок годности (на английском)",
    shelfAr: "Срок годности (на арабском)",
    shelfRu: "Срок годности (на русском)",
    styleEn: "Стиль (на английском)",
    styleAr: "Стиль (на арабском)",
    styleRu: "Стиль (на русском)",
    productTypeEn: "Тип продукта (на английском)",
    producTypeAr: "Тип продукта (на арабском)",
    productTypeRu: "Тип продукта (на русском)",
    placeOfOrigin: "Страна происхождения",
    stock: "Доступное количество",
    priceUnit: "Цена за единицу",
    select: "Выбрать",
    makeAsPackage: "Создать как пакет",
    quantityPerUnit: "Количество в единице",
    pricePerUnit: "Цена за единицу",
    minPerchaseQty: "Минимальное количество для покупки (в единицах)",
    descEng: "Описание (на английском)",
    descAr: "Описание (на арабском)",
    descRu: "Описание (на русском)",
    bulkPricing: "Оптовое ценообразование",
    minQty: "Минимальное количество",
    maxQty: "Максимальное количество",
    remove: "Удалить",
    addBulk: "Добавить оптовую цену",
    pricePerKg: "Цена за кг",
    pricePerLiter: "Цена за литр",
    minQtyKg: "Минимальное количество для покупки (в кг)",
    minQtyLiter: "Минимальное количество для покупки (в литрах)",
    selectDateRange: "Выбрать диапазон дат",
    quotedSubmitted: "Коммерческое предложение отправлено",
    quoteNotSubmitted: "Коммерческое предложение не отправлено",
    editBanner: "Редактировать баннер",
    createBannerFor: "Создать баннер для",
    discountNameEn: "Название скидки на английском",
    discountNameAr: "Название скидки на арабском",
    discountNameRu: "Название скидки на русском",
    discountPer: "Процент скидки",
    addBannerImage: "Добавить изображение баннера",
    orderDetails: "Детали заказа",
    customerDetails: "Данные клиента",
    productsOrdered: "Заказанные товары",
    regNo: "Регистрационный номер",
    orderedQty: "Заказанное количество",
    myProfile: "Мой профиль",
    changePassword: "Сменить пароль",
    logout: "Выйти",
    currentPass: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmPass: "Подтвердите пароль",
    daily: "Ежедневно",
    weekly: "Еженедельно",
    monthly: "Ежемесячно",
    yearly: "Ежегодно",
    customerRejected: "Клиент успешно отклонён",
    customerAccepted: "Клиент успешно принят",
    userDeleted: "Пользователь успешно удалён",
    customerActivated: "Клиент успешно активирован",
    customerDeactivated: "Клиент успешно деактивирован",
    requestReceived: "Запрос получен",
    vendorAccepted: "Продавец принял",
    vendorRejected: "Продавец отклонил",
    pickupScheduled: "Забор запланирован",
    pickedUp: "Забрано",
    inTransit: "В пути",
    receivedByVendor: "Получено продавцом",
    returnComplete: "Возврат завершён",
    vendorAcceptedReq: "Продавец принял запрос",
    vendorRejectedReq: "Продавец отклонил запрос",
    ExchangeInit: "Обмен инициирован",
    itemPickedUp: "Товар забран",
    itemInTransit: "Товар в пути",
    itemReceivedByVendor: "Товар получен продавцом",
    replacementDispatched: "Замена отправлена",
    replacementDelivered: "Замена доставлена",
    exchangeComplete: "Обмен завершён",
    returnStatusUpdatedTo: "Статус возврата обновлён на",
    exchangeStatusUpdatedTo: "Статус обмена обновлён на",
    orderAcceptedSuccessFully: "Заказ успешно принят",
    orderRejectedSuccessfully: "Заказ успешно отклонён",
    updatedSuccess: "Успешно обновлено",
    send: "Отправить",
    editVendor: "Редактировать продавца",
    vendorProfile: "Профиль продавца",
    profileDetails: "Детали профиля",
    docs: "Документы",
    areYouSure: "Вы уверены, что хотите удалить это?",
    yes: "Да",
    no: "Нет",
    productAdded: "Товар успешно добавлен",
    productUpdated: "Товар успешно обновлён",
    productDetails: "Детали товара",
    sendQuotation: "Отправить предложение",
    chatInbox: "Входящие чаты",
    typeMessage: "Введите сообщение...",
    chatDetails: "Детали чата",
    timeFrame: "Промежуток времени (часы)",
    selectProduct: "Выберите товар",
    lastWeek: "Прошлая неделя",
    lastMonth: "Прошлый месяц",
    lastYear: "Прошлый год",
    bannerDetails: "Просмотреть детали баннера",
    uploadBanner: "Пожалуйста, загрузите изображение для баннера",
    bannerUpdated: "Баннер успешно обновлён",
    bannerAdded: "Баннер успешно добавлен",
    discountDetails: "Просмотреть детали скидки",
    discountAdded: "Скидка успешно добавлена",
    discountUpdated: "Скидка успешно обновлена",
    editDiscount: "Редактировать скидку",
    accepted: "Принято",
    refundedSuccess: "Возврат выполнен успешно",
    exchangeRefunds: "Возвраты по обмену",
    returnRefunds: "Возвраты по возврату",
    refunded: "Возвращено",
    notificationTitle: "Заголовок уведомления",
    notificationMessage: "Сообщение уведомления",
    receiverType: "Выберите тип получателя",
    notificationType: "Выберите тип уведомления",
    notification: "Уведомление",
    settingsAdded: "Настройки успешно добавлены",
    settingsUpdated: "Настройки успешно обновлены",
    addSettings: "Добавить настройку",
    selectType: "Выберите тип",
    taxPer: "Налог (%)",
    commissionPer: "Комиссия платформы (%)",
    cmsUpdated: "Поддержка обновлена успешно",
    conversionUpdated: "Курс конверсии успешно обновлён",
    selectRole: "Пожалуйста, выберите роль",
    editSubAdmin: "Редактировать суб-администратора",
    addRole: "Добавить роль",
    selectRole1: "Выберите роль",
    module: "Модуль",
    addEdit: "Добавить/Редактировать",
    view: "Просмотр",
    loginSuccess: "Успешный вход в систему.",
    profileUpdated: "Profile Updated Successfully.",
    subAdminUpdated: "Sub Admin Status Updated successfully.",
    broadcast: "Broadcast",
    user: "User",
    vendor: "Vendor",
    selectAll: "Select All",
    remarks: "Remarks",
    amount: "Amount",
    showing: "Showing",
    items: "Items",
    exchange: "Exchange",
    return: "Return",
    updateDiscount: "Update Discount",
    discountActivated: "Discount Activated Successfully",
    discountDeactivated: "Discount Deactivated Successfully",
    passChanged: "Password changed successfully",
  },
  dashboard: {},
  sideBar: {
    dashboard: "Панель управления",
    registration: "Регистрация",
    manageCustomers: "Управление клиентами",
    manageVendors: "Управление поставщиками",
    manageCategories: "Управление категориями",
    manageProducts: "Управление товарами",
    manageQuotes: "Управление предложениями",
    manageBanners: "Управление баннерами",
    manageDiscount: "Управление скидками",
    manageOrders: "Управление заказами",
    manageReturnExchange: "Управление возвратами и обменами",
    manageRefunds: "Управление возвратами",
    manageChats: "Управление чатами",
    managePayments: "Управление платежами",
    analytics: "Аналитика",
    notificationManagement: "Управление уведомлениями",
    manageSubAdmin: "Управление суб-админами",
    settings: "Настройки",
    general: "Общие",
    manageCms: "Управление CMS",
    conversionRate: "Курс обмена",
  },
  error: {
    required: "Это поле обязательно для заполнения",
    validation1: "Пожалуйста, выберите допустимое видео",
    maxValidation: "Допускается не более 80 символов",
    minValidation: "Требуется минимум 3 символа",
    noData: "Результатов не найдено",
    titlereq: "Заголовок обязателен",
    descReq: "Описание обязательно",
    noFaq: "Список часто задаваемых вопросов не найден",
    emailReq: "Электронная почта обязательна!",
    validEmail: "Введите действительный адрес электронной почты!",
    firstReq: "Имя обязательно",
    lastReq: "Фамилия обязательна",
    phoneReq: "Номер телефона обязателен",
    minPhone: "Номер телефона должен содержать не менее 6 цифр",
    maxPhone: "Номер телефона должен содержать не более 16 цифр",
    subAdminCreated: "Суб-администратор успешно создан",
    subAdminUpdate: "Суб-администратор успешно обновлён",
    userUpdate: "Пользователь успешно обновлён",
    statusUpdate: "Статус успешно обновлён",
    subAdminDel: "Суб-администратор успешно удалён",
    userDel: "Пользователь успешно удалён",
    max100: "Допускается максимум 100 символов",
    max250: "Допускается максимум 250 символов",
    max500: "Допускается максимум 500 символов",
    catAdd: "Категория успешно добавлена",
    catUpdate: "Категория успешно обновлена",
    settingUpdate: "Настройки успешно обновлены",
    faqAdd: "FAQ успешно добавлен",
    faqDel: "FAQ успешно удалён",
    cmsUpdate: "CMS успешно обновлён",
    messageReq: "Сообщение обязательно",
    notiAdd: "Уведомление успешно добавлено",
    notiDel: "Уведомление успешно удалено",
    logutReq: "Вы уверены, что хотите выйти?",
    noUserFound: "Пользователь не найден",
    noVendorFound: "Продавец не найден",
    noSubFound: "Подкатегория не найдена",
    noChatFound: "Чаты не найдены",
    noDocs: "Нет доступных документов.",
    noImage: "Пожалуйста, загрузите изображение",
    incorrectOtp: "Неверный код подтверждения. Попробуйте снова.",
    enterOtp: "Пожалуйста, введите код подтверждения",
    noEmoji: "Эмодзи не допускаются в адресе электронной почты",
    newPassReq: "Требуется новый пароль.",
    passValid:
      "Пароль должен содержать не менее 8 символов, включая одну заглавную букву, одну строчную букву, одну цифру и один специальный символ (@$!%*?&)",
    newCannotBeOld: "Новый пароль не может быть таким же, как текущий.",
    mustMatch: "Пароли должны совпадать.",
    confirmPassReq: "Требуется подтверждение пароля.",
    passReset: "Пароль успешно сброшен",
    max40: "Максимум 80 символов разрешено",
    pleaseUploadImage: "Пожалуйста, загрузите изображения",
    fillMinimum: "Пожалуйста, укажите минимальное количество",
    fillMaximum: "Пожалуйста, укажите максимальное количество",
    fillPrice: "Пожалуйста, укажите цену",
    max10Image: "Максимум 10 изображений разрешено",
    pleaseWrite: "Пожалуйста, напишите что-нибудь",
    minBanner: "Минимальные размеры баннера должны быть 498×500",
    atLeast1Receiver: "Пожалуйста, выберите хотя бы одного получателя",
    oneNotificationType: "Пожалуйста, выберите хотя бы один тип уведомления",
    currentPassRequired: "Current password is required",
    min8: "Minimum 8 characters are required",
  },
  messages: {},
};
